export enum InquiryReason {
	Question = 0,
	Assistance = 1,
	Problem = 2,
	Suggestion = 3,
}
